import { timezoneDate } from '@/common/utils/DateManager';

export default {
  setUserNo(state, { userNo }) {
    state.userNo = userNo;
  },
  setStore(state, storeInfo) {
    state.storeNo = storeInfo.store.storeNo;
    state.storeInfo = storeInfo;
  },
  setCart(state, cart = []) {
    state.cart = cart;
  },
  setOrderType(state, orderType) {
    state.orderType = orderType;
  },
  setUserInfo(state, { userNo = null, name = '' }) {
    state.userNo = userNo;
    state.name = name;
  },
  setLocation(state, { longitude = 0, latitude = 0 }) {
    state.longitude = longitude;
    state.latitude = latitude;
  },

  setCoupon(state, coupon) {
    state.coupon = coupon;
  },
  setAddress(state, address) {
    state.address = address;
  },
  setAddressDetail(state, addressDetail) {
    state.addressDetail = addressDetail;
  },
  setPhone(state, phone) {
    state.phone = phone;
  },
  setInquiry(state, { inquiry = '', remindInquiry = false }) {
    state.inquiry = inquiry;
    state.remindInquiryLater = remindInquiry;
  },
  setReservedDate(state, setReservedDate) {
    state.reservedDate = setReservedDate;
  },

  setPaymentMethod(state, paymentMethod) {
    state.paymentMethod = paymentMethod;
  },
  setTotalProductsPrice(state, price) {
    state.totalProductsPrice = price;
  },
  setDeliveryFee(state, fee) {
    state.deliveryFee = fee;
  },
  setDiscountAmount(state, discount) {
    state.discountAmount = discount;
  },
  setPointUsageAmount(state, pointUsageAmount) {
    state.pointUsageAmount = pointUsageAmount;
  },
  setCouponDiscountAmount(state, couponDiscountAmount) {
    state.couponDiscountAmount = couponDiscountAmount;
  },
  setBalance(state, balance) {
    state.balance = balance;
  },
  setOrderNo(state, orderNo) {
    state.orderNo = orderNo;
  },
  setOrderManageNo(state, orderManageNo) {
    state.orderManageNo = orderManageNo;
  },
  setOrderDateNow(state) {
    state.orderDate = timezoneDate();
  },
  setAutomaticWithdrawalInformation(state, { bank = '', accountNumber = '', depositHolder = '' }) {
    state.bank = bank;
    state.accountNumber = accountNumber;
    state.depositHolder = depositHolder;
  },

  purgeCoupon(state) {
    state.coupon = null;
  },
  purge(state) {
    //state = ~ 는 persist에서 인식 X
    state.orderNo = -1;
    state.storeNo = 0;
    state.userNo = 0;
    state.orderManageNo = null;
    state.name = '';
    state.phone = '';
    state.address = '';
    state.addressDetail = '';
    state.longitude = 0;
    state.latitude = 0;
    state.memo = '';
    state.bank = '';
    state.accountNumber = '';
    state.depositHolder = '';
    state.orderType = null;
    state.orderDate = timezoneDate();
    state.reservedDate = null;
    state.inquiry = '';
    state.remindInquiryLater = false;
    state.paymentMethod = null;
    state.totalProductsPrice = 0;
    state.deliveryFee = 0;
    state.discountAmount = 0;
    state.couponDiscountAmount = 0;
    state.pointUsageAmount = 0;
    state.balance = 0;
    state.cart = [];
    state.coupon = null;
    state.storeInfo = {
      store: {
        storeNo: 0,
        userNo: 0,
        storeCategoryNo: 0,
        storeTypeNo: 0,
        locationNo: 0,
        owner: '',
        phone: '',
        nameKr: '',
        nameVn: '',
        address: '',
        addressDetail: '',
        tagVn: '',
        tagKr: '',
        blog: '',
        youtube: '',
        hasOffline: '',
        isActive: '',
        isShow: '',
        isWork: '',
        isDeliverable: false,
        isChattable: false,
        isQueryable: false,
        isSupportDelivery: false,
        isSupportPacking: false,
        isSupportVisit: false,
        isViaCash: false,
        isViaCard: false,
        isViaAutomaticWithdrawal: false,
        isViaOnlinePayment: false,
        isPointAvailable: false,
        introduceKr: '',
        introduceVn: '',
        noticeKr: '',
        noticeVn: '',
        regDate: '',
        updateDate: '',
        supportLanguage: '',
        baseDeliveryFee: 0,
        baseDeliveryFeeLimit: 0,
        increaseDeliveryFeePer: 0,
        additionalDeliveryFee: 0,
        maximumDeliveryFee: 0,
        noDeliveryFeeWhen: 0,
        minimumPriceForDelivery: 0,
        minimumDeliveryDuration: 0,
        maximumDeliveryDuration: 0,
        ifAcceptDelivery: 0,
        exceedMinutes: 0,
        discountWhenPack: 0,
        orderCommissions: 0,
        lastCommissionModifiedDate: 0,
        latitude: 0,
        longitude: 0,
        storeNoticeKr: '',
        storeNoticeVn: ''
      }
    };
  },
  setInvalidStockList: (state, list = []) => (state.invalidStockList = list)
};
